import type { ReactNode } from 'react';
import { TaskSidebarPanel } from '../TaskSidebarPanel';
import { buildSidebarTabs, OPS_TABS } from '../taskSidebarTabs';
import {
    VersionedPdfPane,
    type DocumentVersion,
    type VersionsFetchState
} from './VersionedPdfPane';

interface ReviewSurfaceProps {
    patientId: string;
    versions: DocumentVersion[];
    docLabel: string;
    versionsState: VersionsFetchState;
    onRetryVersions?: () => void;
    hasMoreVersions?: boolean;
    /** Rendered below the sidebar tabs in the right column (e.g. an actions card). Omit for a view-only surface. */
    actionsSlot?: ReactNode;
}

// Shared layout for every clinical-document review task: the versioned PDF
// pane (~59%) beside the clinical sidebar tabs, with an optional actions slot.
export function ReviewSurface({
    patientId,
    versions,
    docLabel,
    versionsState,
    onRetryVersions,
    hasMoreVersions,
    actionsSlot
}: ReviewSurfaceProps) {
    return (
        <div className="flex-1 min-h-0 flex gap-3 px-4 pt-3 pb-3">
            <div className="flex-[0_0_59%] min-w-0 min-h-0">
                <VersionedPdfPane
                    patientId={patientId}
                    versions={versions}
                    docLabel={docLabel}
                    versionsState={versionsState}
                    onRetryVersions={onRetryVersions}
                    hasMoreVersions={hasMoreVersions}
                />
            </div>

            <div className="flex-1 min-w-0 min-h-0 flex flex-col gap-3">
                <div className="flex-1 min-h-0">
                    <TaskSidebarPanel tabs={buildSidebarTabs(patientId, OPS_TABS)} />
                </div>
                {actionsSlot}
            </div>
        </div>
    );
}
